import SiteNav from "./components/SiteNav";
import HeroSection from "./components/HeroSection";
import QuickFactsSection from "./components/QuickFactsSection";
import TimelineSection from "./components/TimelineSection";
import TopicSection from "./components/TopicSection";
import DetailSection from "./components/DetailSection";
import SocialSection from "./components/SocialSection";
import FaqSection from "./components/FaqSection";
import ClosingSection from "./components/ClosingSection";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-sans">
      <SiteNav />
      <main>
        <HeroSection />
        <QuickFactsSection />
        <TimelineSection />
        <TopicSection />
        <DetailSection />
        <SocialSection />
        <FaqSection />
        <ClosingSection />
      </main>
      <SiteFooter />
    </div>
  );
}